"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMenuState = void 0;
const tslib_1 = require("tslib");
const react_use_controlled_state_1 = tslib_1.__importDefault(require("@quid/react-use-controlled-state"));
const react_1 = require("react");
const compound_components_1 = require("@clds/compound-components");
const useSyncOnChange = (observerValue, syncCallback) => {
    (0, react_1.useLayoutEffect)(() => {
        if (observerValue !== undefined && observerValue !== compound_components_1.unselect) {
            syncCallback(observerValue);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [observerValue]);
};
const useMenuState = (props) => {
    const [focusedId, setFocusedId] = (0, react_use_controlled_state_1.default)(props.defaultFocusedId === undefined && props.focusedId === undefined
        ? compound_components_1.unselect
        : props.defaultFocusedId, props.focusedId, props.onFocusedIdChange);
    const [selectedId, setSelectedId] = (0, react_use_controlled_state_1.default)(props.defaultSelectedId === undefined && props.selectedId === undefined
        ? compound_components_1.unselect
        : props.defaultSelectedId, props.selectedId, props.onSelect);
    useSyncOnChange(selectedId, setFocusedId);
    const cancel = () => {
        setFocusedId(compound_components_1.unselect);
        setSelectedId(compound_components_1.unselect);
    };
    const select = (id) => {
        setFocusedId(id);
        setSelectedId(id);
    };
    return {
        focusedId,
        setFocusedId,
        selectedId,
        cancel,
        select,
    };
};
exports.useMenuState = useMenuState;
//# sourceMappingURL=useMenuState.js.map